module.exports = __webpack_public_path__ + "static/img/cultural.ab428f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/cultural.png
// module id = 928
// module chunks = 0